export enum UserRole {
    ADMIN = 'Admin',
    SUPER_ADMIN = 'SuperAdmin'
}